// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"32fdcf0d","875":"ae5d450b","968":"04cb3524"}[chunkId] + ".chunk.js";
};